import gql from 'graphql-tag';

import actionTypes from './constants';

/* */
export const getInterests = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${actionTypes.gql.GET_INTERESTS}
      `,
      fetchPolicy,
      variables,
    })
    .then((res) => res.data)
    .then((data) => data.getAccountInterests);

/* */
export const getAccountByToken = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${actionTypes.gql.GET_ACCOUNT_BY_TOKEN}
      `,
      fetchPolicy,
      variables,
    })
    .then((res) => res.data)
    .then((data) => data.getAccountByToken);

/* */
export const setInterests = (client, variables) => client.mutate({
    mutation: gql`
      ${actionTypes.gql.SET_INTERESTS}
    `,
    variables,
  });

/* */
export const getStatement = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${actionTypes.gql.GET_STATEMENT}
      `,
      fetchPolicy,
      variables,
    })
    .then((res) => res.data)
    .then((data) => data.getAccountStatement);

/* */
export const getAccountPrima = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${actionTypes.gql.GET_INFO_PRIMA}
      `,
      fetchPolicy,
      variables,
    })
    .then((res) => res.data)
    .then((data) => data.getAccountPrima);

/* */
export const setAccountPrima = (client, variables) => client.mutate({
    mutation: gql`
      ${actionTypes.gql.SET_INFO_PRIMA}
    `,
    variables,
  });

/* */
export const setPrivacy = (client, variables) => client.mutate({
    mutation: gql`
      ${actionTypes.gql.SET_PRIVACY}
    `,
    variables,
  });

/* */
export const matchInGolf = (client, variables) => client.mutate({
    mutation: gql`
      ${actionTypes.gql.MATCH_ACCOUNT}
    `,
    variables,
  });

/* */
export const setCovidCertificateOwned = (client, variables) => client.mutate({
    mutation: gql`
      ${actionTypes.gql.SET_COVID_CERTIFICATE_OWNED}
    `,
    variables,
  });

/* */
export const getHcpIndexFFG = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${actionTypes.gql.GET_HCP_INDEX_FFG}
      `,
      fetchPolicy,
      variables,
    })
    .then(({ data }) => data.getAccountIndexFFG);
